import { FC } from 'react';
import classNames from 'classnames';

import IconRight from 'images/icon-right.svg';

import styles from './PricingMenuItem.module.scss';

const PRICE_LOCALE = {
  currency: 'JPY',
  style: 'currency',
};

interface Props {
  description: string;
  hasPadding?: boolean;
  isArrowShown?: boolean;
  isHighlighted?: boolean;
  priceRangeEnd?: number;
  priceRangeStart: number;
  variant?: 'flat' | 'raised';
}

const PricingMenuItem: FC<Props> = ({
  description,
  isArrowShown,
  isHighlighted,
  priceRangeStart,
  priceRangeEnd,
  hasPadding = true,
  variant = 'raised',
}) => {
  const priceStart = priceRangeStart.toLocaleString('ja-JP', PRICE_LOCALE);
  const priceDisplay = priceRangeEnd
    ? `${priceStart} 〜 ${priceRangeEnd.toLocaleString('ja-JP', PRICE_LOCALE)}`
    : priceStart;

  return (
    <div
      className={classNames(styles.container, styles[variant], {
        [styles.highlighted]: isHighlighted,
        [styles['with-padding']]: hasPadding,
      })}
    >
      <div className={styles['main-content']}>
        <p className={classNames(styles.description, styles[`description-${variant}`])}>
          {description}
        </p>
        {isArrowShown && (
          <div className={styles['right-arrow']}>
            <IconRight
              data-test-id="icon-right"
              className={classNames({ [styles['right-arrow-highlighted']]: isHighlighted })}
            />
          </div>
        )}
      </div>
      <p className={classNames(styles.price, styles[`price-${variant}`])}>{priceDisplay}</p>
    </div>
  );
};

export type { Props as PricingMenuItemProps };

export default PricingMenuItem;
